module.exports = __webpack_public_path__ + "media/images/icon_list/chevron_down-8b82f05f772d6beb431d810131811e07.svg";